var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pcase)?_c('div',{staticClass:"case"},[(_vm.pcase.schedule && _vm.pcase.schedule.assignee)?_c('DoctorCard',{attrs:{"doctor-id":_vm.pcase.schedule.assignee.id}}):_vm._e(),_c('PatientCase',{attrs:{"value":_vm.pcase.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }